const API_HOST = process.env.VUE_APP_API_HOST || 'localhost:3333';
const API_DOMAIN = process.env.VUE_APP_API_DOMAIN || `http://${API_HOST}`;
const API_BASE_URL = `${API_DOMAIN}/api`;
const AUTH_TOKEN_ENDPOINT = '/auth/token';
const AUTH_TOKEN_REFRESH_ENDPOINT = '/auth/refresh';
const USER_ENDPOINT = '/auth/user';

export {
    API_DOMAIN,
    API_HOST,
    API_BASE_URL,
    AUTH_TOKEN_ENDPOINT,
    AUTH_TOKEN_REFRESH_ENDPOINT,
    USER_ENDPOINT,
};
